"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLimitWithManualSlippage = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const utils_1 = require("@shapeshiftoss/utils");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const getLimitWithManualSlippage = ({ expectedAmountOutThorBaseUnit, slippageBps, }) => {
    const limitWithManualSlippage = (0, utils_1.subtractBasisPointAmount)((0, chain_adapters_1.bn)(expectedAmountOutThorBaseUnit).toFixed(0, bignumber_js_1.default.ROUND_DOWN), slippageBps, bignumber_js_1.default.ROUND_DOWN);
    return limitWithManualSlippage;
};
exports.getLimitWithManualSlippage = getLimitWithManualSlippage;
